import {
  BrandKey,
  GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult,
} from '../../../../__generated__/queries-web';

export const loadScript = (
  src: string,
  success?: () => void,
  error?: () => void,
) => {
  const scriptDom = document.getElementById(src);
  if (scriptDom) {
    return;
  }

  const script = document.createElement('script');
  script.setAttribute('src', src);
  script.setAttribute('id', src);

  if (success) {
    script.addEventListener('load', success);
  }

  if (error) {
    script.addEventListener('error', error);
  }

  document.body.appendChild(script);

  return () => {
    if (success) {
      script.removeEventListener('load', success);
    }
    if (error) {
      script.removeEventListener('error', error);
    }
  };
};

export const getModelId = (
  models: GetAffilizzDesignsQuery_query_searchAffiliationDesign_searchAffilizzDesignResult[],
) => {
  const preferredResult = models.find(
    (m) => m.renderingType === 'CARD' && m.defaultDesign === true,
  );

  if (preferredResult) {
    return preferredResult.id;
  }

  return config.AFFILIZZ_MODEL_IDS['DEFAULT'];
};

export function getMediaId(brandKey?: BrandKey): string {
  switch (brandKey) {
    case BrandKey.CAP:
      return '659d202a507a445dabd7ecb6';

    case BrandKey.CAC:
      return '668e4b38aa64d372215a7742';

    case BrandKey.FAC:
      return '63e4f2ff8d931a59ca719abf';

    case BrandKey.GEO:
      return '67e57f9e97b39e7d89e37b71';

    case BrandKey.VOI:
      return '67a328dfe0e3ad46bd9b867e';

    case BrandKey.TEL:
      return '67e5950ca1d1ff3a3ce3826b';

    case BrandKey.TLS:
      return '67e5967ea1d1ff3a3ce3826d';

    default:
      return '669fdf7eaa64d372215a77f9';
  }
}
